import React, { useState } from 'react'
import { supabase } from '../supabase'
import './ConstructionRecordForm.css' // 重用相同的樣式

const LoginForm = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  
  // 移除硬編碼的管理員郵箱檢查，改用動態權限系統

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      if (!supabase) {
        throw new Error('Supabase 客戶端未正確初始化')
      }

      // 使用 Supabase Auth 進行登入
      const { data, error } = await supabase.auth.signInWithPassword({
        email: formData.email,
        password: formData.password
      })

      if (error) {
        throw error
      }

      // 登入成功，不再檢查硬編碼的管理員郵箱
      // 權限檢查由 WellList 組件的權限系統處理
      
      // 保存登入狀態和用戶資訊
      localStorage.setItem('isLoggedIn', 'true')
      localStorage.setItem('loginTime', Date.now().toString())
      localStorage.setItem('userEmail', formData.email)
      localStorage.setItem('accessToken', data.session.access_token)
      
      // 清空表單
      setFormData({
        email: '',
        password: ''
      })

      // 成功回調
      if (onSuccess) {
        onSuccess(data.user)
      }

      alert('登入成功！')
      onClose()
    } catch (error) {
      console.error('登入失敗:', error)
      
      // 根據錯誤類型提供友善的錯誤訊息
      if (error.message.includes('Invalid login credentials')) {
        setError('郵箱或密碼錯誤')
      } else if (error.message.includes('Email not confirmed')) {
        setError('請先確認您的郵箱')
      } else if (error.message.includes('Too many requests')) {
        setError('登入嘗試次數過多，請稍後再試')
      } else if (error.message.includes('Supabase 客戶端未正確初始化')) {
        setError('系統設定錯誤，請聯繫管理員')
      } else {
        setError('登入失敗：' + (error.message || '未知錯誤'))
      }
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '400px' }}>
        <div className="modal-header">
          <h2>用戶登入</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="construction-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-section">
            <p style={{ color: '#6c757d', marginBottom: '20px', textAlign: 'center' }}>
              登入後可根據您的權限進行相應操作
            </p>
            
            <div className="form-group">
              <label>郵箱</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="請輸入郵箱地址"
              />
            </div>
            
            <div className="form-group">
              <label>密碼</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="請輸入密碼"
              />
            </div>
            
            <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '10px' }}>
              登入後系統會根據您的權限等級顯示可用功能
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? '登入中...' : '登入'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default LoginForm 